import React from 'react';
import styleProgressBar from './ProgressBar.module.scss';
import { useSelector } from 'react-redux';

const ProgressBar = (props) => {

    const titolo = props.titolo;
    const lista = (props.sottoCampi).split(',');
    const stepCorrente = useSelector(state => state.dataReducer.modello.currentStep);
    let altezzaProgressStep = `height: 0px`;
    let stepAttivo = 0;

    if(stepCorrente === 1 || stepCorrente === 5){
        altezzaProgressStep = `${styleProgressBar.altezza40}`;
    }else if(stepCorrente === 2 || stepCorrente === 6){
        altezzaProgressStep = `${styleProgressBar.altezza55}`;
    }else if(stepCorrente === 3 || stepCorrente === 7){
        altezzaProgressStep = `${styleProgressBar.altezza70}`;
    }else if(stepCorrente === 4 || stepCorrente === 8){
        altezzaProgressStep = `${styleProgressBar.altezza90}`;
    }else if(stepCorrente === 9){
        altezzaProgressStep = `${styleProgressBar.altezza40}`;
    }else if(stepCorrente === 10){
        altezzaProgressStep = `${styleProgressBar.altezza90}`;
    }

    if(stepCorrente === 1 || stepCorrente === 5){
        stepAttivo = 0;
    }else if(stepCorrente === 2 || stepCorrente === 6){
        stepAttivo = 1;
    }else if(stepCorrente === 3 || stepCorrente === 7){
        stepAttivo = 2;
    }else if(stepCorrente === 4 || stepCorrente === 8){
        stepAttivo = 3;
    }else if(stepCorrente === 9){
        stepAttivo = 0;
    }else if(stepCorrente === 10){
        stepAttivo = 1;
    }


    const situazione = props.situazione === 'progress' ? `${styleProgressBar.Progress}` : props.situazione === 'completato' ? `${styleProgressBar.Completato}` : props.situazione === 'non_completato' ? `${styleProgressBar.NonCompletato}` : null;


    return (
        <div className={`${styleProgressBar.ContenitoreProgressBar}`}>
            <h1 className={styleProgressBar.Titolo}>{titolo}</h1>
            <div className={`${styleProgressBar.ProgressBar} ${situazione}`}>
                <span className={`${styleProgressBar.ProgressStep} ${altezzaProgressStep}`}></span>
            </div>
            <div className={styleProgressBar.listaStep}>
                {lista.map( (step,key) => (
                    (key === stepAttivo) ? (
                        <p key={key} className={`${styleProgressBar.singoloStep} ${styleProgressBar.singoloStepAttivo} `}>{step}</p>
                    ) : (
                        <p key={key} className={styleProgressBar.singoloStep}>{step}</p>
                    )
                ))}
            </div>
        </div>
    )
}

export default ProgressBar;